module.exports = __webpack_public_path__ + "img/digitalplanet2025.123ef28b.png";